// Fades and rises elements marked [data-reveal] into view as they enter the
// viewport, and replays that animation every time the element re-enters —
// scroll away and back and it plays again, not just once per page load.
const revealEls = document.querySelectorAll('[data-reveal]');

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    entry.target.classList.toggle('in-view', entry.isIntersecting);
  });
}, { threshold: 0.15 });

revealEls.forEach((el, i) => {
  el.style.transitionDelay = (i % 4) * 90 + 'ms';
  revealObserver.observe(el);
});
